module.exports = __webpack_public_path__ + "3a20388f.png";